/** 首页 */
import React from 'react';

import "../css/HomePage.css"

import Config from "../config/Config";
import Cache from "../frame/Cache";
import WidgetAjax from "../widget/WidgetAjax";
import WidgetChart from '../widget/WidgetChart';
import WidgetComponent from './../widget/WidgetComponent';
import MatterListWidget from './HomePageWidget/MatterListWidget';
import AllRankingWidget from './HomePageWidget/AllRankingWidget';
import WidgetDrawer from '../widget/WidgetDrawer';
import EntityDetail from './EntityDetail';

import VIEWS from "../img/home/VIEWS.svg"
import VIEWSPitchOn from "../img/home/VIEWS-PitchOn.svg"
import CALLS from "../img/home/CALLS.svg"
import CALLSPitchOn from "../img/home/CALLS-PitchOn.svg"
import DOWNLOADS from "../img/home/DOWNLOADS.svg"
import DOWNLOADSPitchOn from "../img/home/DOWNLOADS-PitchOn.svg"
import titleLeft from "../img/home/TitleLeft.svg"
import MoreBtn from "../img/home/MoreBtn.svg"


class HomePage extends WidgetComponent
{
    constructor( props )
    {
        super(props);

        const url = Config.getBasePath()

        this.state = {
            url:url,
            BasePath:Config.getBasePath(),
            workQuotaLogo:[{}],
            workQuotar:[],
            enterpriseWarning:[],
            businessWarning:[],
            workQuotaTabsBody:"VIEWS",
            mattersTabsBody:[],
            workQuotaTabNum:"VIEWS",
            chart1 : {
                'schemas':[
                    {'name':'S002001', dimensions:["D203"]}
                ],
                'type':'pie',
                'properties' : {
                    'theme':'TH001'
                }
            },
            chart2 : {
                'schemas':[
                    {'name':'S002002', dimensions:["D203", "D005"]}
                ],
                'type':'area',
                'properties' : {
                    'theme':'TH001'
                } 
            },
            MouseOverId:'',
            loading:true,
            detailData:undefined,
            drawerOptions: {
                size: 'lg',
                button: false,
            },
            flag : 1
        };

        this.loadQuota = this.loadQuota.bind(this);
        this.loadMonitor = this.loadMonitor.bind(this);
        this.loadBusiness = this.loadBusiness.bind(this);

        this.onLoadQuota = this.onLoadQuota.bind(this);
        this.onloadMonitor = this.onloadMonitor.bind(this);
        this.onloadBusiness = this.onloadBusiness.bind(this);
        this.messageWarningJump = this.messageWarningJump.bind(this)
        this.preHandleChartEvent = this.preHandleChartEvent.bind(this);

        this.businessWarningDetail = this.businessWarningDetail.bind(this)

        
        let path = Config.getBasePath();

        this.bindConsole(path);

    }

    /**
     * 初始化workQuota要渲染的内容
     */
    componentDidMount()
    {
        //初始化请求
        this.loadQuota();
        this.loadMonitor();
        this.loadBusiness();
    }

    /**
     * 请求商机个人额度
     */
    loadQuota()
    {

        let { BasePath } = this.state;

        WidgetAjax.ajax({url: BasePath + "/business/quota", params: undefined , callback: this.onLoadQuota});
    }

    onLoadQuota( result )
    {
        if( result.status===0 )
        {
            this.setState({
                workQuotar:result.result
            })
        }
        else if( result.status===10 ) 
        {
            Cache.logout(this.props);
        }
    }

    
    /**
     * 请求重点企业数据
     */
    loadMonitor()
    {
        let { BasePath } = this.state;

        let params = {
            page:1,
            records:6,
        }
        try{
            WidgetAjax.ajax({url: BasePath + "/push/monitor", params: params , callback: this.onloadMonitor});
            this.setState({ loading: true });
        }catch{

        }
    }
    
    onloadMonitor( result )
    {
        if( result.status===0 )
        {
            this.setState({enterpriseWarning:result.results,loading:false});
        }
        else if( result.status===10 ) 
        {
            Cache.logout(this.props);
        }
    }

    /**
     * 请求商机发现数据
     */
    loadBusiness()
    {
        let { BasePath } = this.state;

        let params = {
            page:1,
            records:6,
        }


        WidgetAjax.ajax({url: BasePath + "/push/business", params: params , callback: this.onloadBusiness}); 
        this.setState({loading:true})
    }

    onloadBusiness( result )
    {
        if( result.status===0 )
        {
            this.setState({businessWarning:result.results,loading:false})
        }
        else if( result.status===10 ) 
        {
            Cache.logout(this.props);
        }
    }

    /**
     * 重点商机预警-更多
     */
    businessWarningDetail()
    {
        this.props.history.push('/home/businessChance')
    }

    /**
     * 重点企业预警-更多
     */
    enterpriseWarningDetail()
    {
        this.props.history.push('/home/enterpriseMonitoring')

    }


    /**
     * 工作额度tabs body内容的改变
     * @param {*} type 
     */
    changeTab(type) 
    {
        let filter = {};

        filter["code"] = "D203";
        switch( type )
        {
            case "VIEWS":
            {
                filter["expression"] = "${D203}='1'";
                break;
            }
            case "DOWNLOADS":
            {
                filter["expression"] = "${D203}='2'";
                break;
            }
            case "CALLS":
            {
                filter["expression"] = "${D203}='3'";
                break;
            }
            default :
                break;
        }

        this.sendEvent("set.filter", filter);
        this.setState({workQuotaTabsBody:type });
    }

    preHandleChartEvent(  content, type )
    {
        const { workQuotaTabsBody } = this.state;

        switch( type )
        {
            case "schema" : 
            {
                if( content!==undefined )
                {
                    for( let key in content )
                    {
                        let schema = content[key];

                        if( schema!==undefined  )
                        {
                            if( schema.name==="S002001" )
                            {
                                schema["slice"] = {
                                    "main_measure":"M010201001",
                                    "main_dimension":"D204",
                                    "filters" : {
                                        "D203" : "${D203}='1'"
                                    }
                                };
                            }
                            else if( schema.name==="S002002" )
                            {
                                schema["slice"] = {
                                    "main_measure":"M010201001",
                                    "main_dimension":"D005",
                                    "filters" : {
                                        "D203" :"${D203}='1'",
                                        "D005" :"${D005}>='20210901'"
                                    }
                                };
                            }
                        }
                    }
                }
            }

        }

        return content;
    }

    enterpriseWarningJump(val)
    {
        this.setState({detailData:val});

        this.drawerRef.open();
    }

    messageWarningJump(val,type)
    {
        this.props.history.push({pathname:"/home/businessChance", state:{data:val,type}})
    }

    /** 企业详情信息抽屉句柄 */
    drawerRef = (ref) => {
        this.drawerRef = ref;
    }


    render()
    {
        const { workQuotaTabsBody, enterpriseWarning, workQuotar, businessWarning, chart1, chart2, drawerOptions, loading, detailData,flag } = this.state;

        return (
            <div className="page page-overflow overflow-auto">
               <div className="homeBodyLeft floatleft ">
                    <div className="work-quota box-shadow marginbottom-16 background-fff radius-5 border-1 overflow-hidden">
                        <ul className=" work-quota-tabtitle liststyle-none cursor-pointer divideEquallyParent">
                            <li onClick={()=>{this.changeTab("VIEWS");}}
                                    className= { workQuotaTabsBody==="VIEWS" ?
                                    "divideEquallyChildren tabtitle-active display-flex justify-center alignitem-center" :
                                    "divideEquallyChildren backgroundColor-FAFCFF  display-flex justify-center alignitem-center "
                                } 
                            >
                                <dl className="workQuotaTabTitle">
                                    <dt className="workQuotaTabTitle-icon floatleft paddingtop-30">
                                        <img draggable={false} className="workQuotaTabLogo" src={workQuotaTabsBody==="VIEWS"?VIEWSPitchOn:VIEWS} />
                                    </dt>
                                    <dd className="floatleft paddingtop-20 paddingleft-20">
                                        <span className="font-24 displayblock font-PingFangFC">{workQuotar.VIEWS}</span>
                                        <p className="font-16 color-646464 font-PingFangFC">{"浏览量工作额度"}</p>
                                    </dd>
                                </dl>
                            </li>

                            <li onClick={()=>{this.changeTab("DOWNLOADS");}}
                                    className= { workQuotaTabsBody==="DOWNLOADS" ?
                                    "divideEquallyChildren tabtitle-active display-flex justify-center alignitem-center" :
                                    "divideEquallyChildren backgroundColor-FAFCFF  display-flex justify-center alignitem-center "
                                } 
                            >
                                <dl className="workQuotaTabTitle">
                                    <dt className="workQuotaTabTitle-icon floatleft paddingtop-30">
                                        <img draggable={false} className="workQuotaTabLogo" src={workQuotaTabsBody=== "DOWNLOADS"? DOWNLOADSPitchOn : DOWNLOADS} />
                                    </dt>
                                    <dd className="floatleft paddingtop-20 paddingleft-20">
                                        <span className="font-24 displayblock font-PingFangFC">{workQuotar.DOWNLOADS}</span>
                                        <p className="font-16 color-646464 font-PingFangFC">{"下载量工作额度"}</p>
                                    </dd>
                                </dl>
                            </li>

                            <li onClick={()=>{this.changeTab("CALLS");}}
                                    className= { workQuotaTabsBody==="CALLS" ?
                                    "divideEquallyChildren tabtitle-active display-flex justify-center alignitem-center" :
                                    "divideEquallyChildren backgroundColor-FAFCFF  display-flex justify-center alignitem-center "
                                } 
                            >
                                <dl className="workQuotaTabTitle">
                                    <dt className="workQuotaTabTitle-icon floatleft paddingtop-30">
                                        <img draggable={false} className="workQuotaTabLogo" src={workQuotaTabsBody==="CALLS"?CALLSPitchOn:CALLS} />
                                    </dt>
                                    <dd className="floatleft paddingtop-20 paddingleft-20">
                                        <span className="font-24 displayblock font-PingFangFC">{workQuotar.CALLS}</span>
                                        <p className="font-16 color-646464 font-PingFangFC">{"外呼量工作额度"}</p>
                                    </dd>
                                </dl>
                            </li>
                        </ul>
                        <div className="work-quota-tabbody flex-1 display-flex flex-row">
                            <div className="remaining paddingleft-30 paddingtop-30">
                                <p className="font-16 paddingleft-40 clear-margin font-PingFangFC color-323232">{"本月剩余浏览量"}</p>
                                <div style={{padding:40, height: 'calc(100% - 40px)'}}>
                                    <WidgetChart parent={this} onRef={this.onRef} notifyEvent={this.notifyEvent} chart={chart1} preHandleEvent={this.preHandleChartEvent}></WidgetChart>
                                </div>
                            </div>
                            <div className="Nearly30Days paddingtop-30">
                                <p className="font-16  paddingleft-40 clear-margin font-PingFangFC color-323232">{"近30日浏览量日变化趋势"}</p>
                                <div style={{padding:40, height: 'calc(100% - 40px)'}}>
                                    <WidgetChart parent={this} onRef={this.onRef} notifyEvent={this.notifyEvent} chart={chart2} preHandleEvent={this.preHandleChartEvent}></WidgetChart>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div className="WarningContent ">
                        <div className="enterpriseWarning floatleft marginright-8 background-fff border-1 radius-5 box-shadow">
                            <div className="WarningTitle lineheight-50">
                                <b className="fontweight-24 font-16 marginleft-10"><img style={{marginRight:"9px"}} src={titleLeft}/>{"重点企业"}</b>
                                <span onClick={()=>{this.enterpriseWarningDetail()}}
                                      className="hover-black font-27 cursor-pointer floatright marginright-24 color-ACACAC "
                                >
                                    <img src={MoreBtn} />
                                </span>
                            </div>
                            
                            <ul className="messageWarning clear-padding flex-1 liststyle-none background">
                                <li className="tableul background-F7FAFF alignitem-center display-flex">
                                    <span className="flex-2 font-16 fontWeight-400 paddingleft-25 font-PingFangFC">{"企业名称"}</span>
                                    <span className="flex-1 font-d16 fontWeight-400 font-PingFangFC">{"预警内容"}</span>
                                    <span className="flex-1 font-16 fontWeight-400 font-PingFangFC textalign-right paddingright-29">{"预警时间"}</span>
                                </li>
                                {loading?<img src={require('./../img/frame/loading.gif')} className="loading-home" alt="es-lint want to get"/>:
                                        <>{  
                                            enterpriseWarning===undefined || enterpriseWarning===null || enterpriseWarning.length===0 ? 
                                            <p style={{width:"100%",textAlign:"center",paddingTop:"100px"}}><img src={require('../css/widget/img/no-data.svg')}></img></p> :
                                                enterpriseWarning.map((val,index)=>{
                                                    return (
                                                            <li className="tableul tableli font-14 alignitem-center display-flex "
                                                                onClick={()=>{this.enterpriseWarningJump(val)}}
                                                                title={val.ENTNAME!=null?val.ENTNAME:''}
                                                                key={index}>
                                                                <span className="flex-2 font-PingFangFC paddingleft-25 color-646464 relative" >
                                                                    {val.ENTNAME!=null?val.ENTNAME.length<=13?val.ENTNAME:val.ENTNAME.slice(0,13)+"...":''}
                                                                </span>
                                                                <span className="flex-1 font-PingFangFC color-323232">{val.MATTER}</span>
                                                                <span className="flex-1 font-PingFangFC color-646464 textalign-right paddingright-29">{val.MATTERDATE}</span>
                                                            </li>
                                                    )
                                                })
                                        }</>
                                    }
                                
                                
                            </ul>
                        </div>
 
                        <div className="businessWarning floatleft background-fff marginleft-8 border-1 radius-5 box-shadow">
                            <div className="WarningTitle lineheight-50">
                                <b className="fontweight-24 font-16 marginleft-10"><img style={{marginRight:"9px"}} src={titleLeft}/>{"商机发现"}</b>
                                <span onClick={()=>{this.businessWarningDetail()}}
                                      className="hover-black font-27 cursor-pointer floatright marginright-16 color-ACACAC "
                                >
                                    <img src={MoreBtn} />
                                </span>
                            </div>
                            <ul className="messageWarning clear-padding flex-1 liststyle-none background ">
                                <li className="tableul background-F7FAFF alignitem-center display-flex">
                                    <span className="flex-2 font-PingFangFC fontWeight-400 paddingleft-25 font-16">{"商机主题"}</span>
                                    <span className="flex-3 font-PingFangFC fontWeight-400 font-16">{"商机目录"}</span>
                                    <span className="flex-1 font-PingFangFC fontWeight-400 font-16 textalign-right paddingright-29">{"新增商机"}</span>
                                </li>
                                    {loading?<img src={require('./../img/frame/loading.gif')} className="loading-home" alt="es-lint want to get"/>:
                                    <>{   
                                        businessWarning!==undefined && businessWarning!==null && businessWarning.length === 0 ? 
                                        <p style={{width:"100%",textAlign:"center",paddingTop:"100px"}}><img src={require('../css/widget/img/no-data.svg')}></img></p> :
                                            businessWarning.map((val,index)=>{
                                                return (
                                                    <li className="tableul font-14 alignitem-center display-flex"
                                                        key={index}>
                                                        <span className="flex-2 tableSpan font-PingFangFC paddingleft-25 color-646464"
                                                            onClick={()=>{this.messageWarningJump(val,"THEME")}}
                                                        >
                                                            {val.THMNAME}
                                                        </span>
                                                        <span className="flex-3 tableSpan font-PingFangFC color-323232"
                                                            onClick={()=>{this.messageWarningJump(val,"CATALOG")}}
                                                        >{val.CTGNAME}</span>
                                                        <span className="flex-1 tableSpan font-PingFangFC color-646464 textalign-right paddingright-29">{val.CHANGES}</span>
                                                    </li>
                                                )
                                            })
                                        }</>
                                    }
                                    
                                
                            </ul>
                        </div>
                    </div>
               </div>

               <div className="homeBodyRight floatleft body-bottom">
                    <MatterListWidget />
                    <AllRankingWidget />
               </div>

               {/* 企业详情 */}
               <WidgetDrawer options={drawerOptions} onRef={this.drawerRef} >
                    <div className="frame-body">
                        <EntityDetail data={detailData} flag={flag} ></EntityDetail>
                    </div>
                </WidgetDrawer>
            </div>
        )
    }
}

export default HomePage